import { BaseService } from "@/services/BaseService";
import type { AdminAppLinks, CurrentUserAppLinks } from "@/types/app-links";

class AppLinksService extends BaseService {
  private adminBasePath = "/admin/app-links";
  private basePath = "/app-links";

  getAdminAppLinks(): Promise<AdminAppLinks> {
    return this.get<AdminAppLinks>(this.adminBasePath);
  }

  updateAdminAppLinks(data: AdminAppLinks): Promise<AdminAppLinks> {
    return this.put<AdminAppLinks>(this.adminBasePath, data);
  }

  getCurrentUserAppLinks(options?: {
    disableToast?: boolean;
  }): Promise<CurrentUserAppLinks> {
    return this.get<CurrentUserAppLinks>(this.basePath, {}, options);
  }
}

export const appLinksService = new AppLinksService();
